import { Exclude, Expose } from 'class-transformer';
import { Company } from 'shared/types';
import { Role } from '../shared/role.enum';
import { ServiceProvider } from './service-provider';

@Exclude()
export class currentDropResponse {
  @Expose()
  currentDropYear: number;
}
@Exclude()
export class FlockListResponse {
  @Expose()
  flockCode: string;

  @Expose()
  breederId: number;

  @Expose()
  flockName: string;

  @Expose()
  breederWebSite: string;

  @Expose()
  role: Role;

  @Expose()
  isOwner: boolean;

  @Expose()
  status: string;

  @Expose()
  company?: Company;

  @Expose()
  serviceProviders: ServiceProvider[];
}

@Exclude()
export class FlockResponse {
  @Expose()
  breedFlockCode: string;

  @Expose()
  breederId: number;

  @Expose()
  flockCode: string;

  @Expose()
  breedId: string;

  @Expose()
  flockVisibility: string;

  @Expose()
  flockGrpName: string;

  @Expose()
  description: string;

  @Expose()
  latestDrop: number;

  @Expose()
  groupType: string;
}
